// auto-generated by Typewriter template _models.tst from PortCall.Wartsila.EndPoints\Api\DataCache\WartsilaDataCacheUpdateEntities.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { EnhancedEstimate, EnhancedEstimateData, EnhancedEstimateOptions } from 'data/models/EnhancedEstimate';
import { EnhancedEstimateQuery, EnhancedEstimateQueryData, EnhancedEstimateQueryOptions } from 'data/models/EnhancedEstimateQuery';

// WartsilaDataCacheUpdateEntitiesData is the class that WartsilaDataCacheUpdateEntities serializes to/from
export interface WartsilaDataCacheUpdateEntitiesData {
	
    EnhancedEstimateQueries : EnhancedEstimateQueryData[] | null;
    EnhancedEstimates : EnhancedEstimateData[] | null;
	
}

// WartsilaDataCacheUpdateEntitiesOptions is the class which may be passed to the WartsilaDataCacheUpdateEntities constructor to define optional initial data values
export interface WartsilaDataCacheUpdateEntitiesOptions {
	
    EnhancedEstimateQueries? : EnhancedEstimateQueryOptions[] | null;
    EnhancedEstimates? : EnhancedEstimateOptions[] | null;
	
}

export class WartsilaDataCacheUpdateEntities {
	
    public EnhancedEstimateQueries : SDataArray<EnhancedEstimateQuery>;
    public EnhancedEstimates : SDataArray<EnhancedEstimate>;
	

    constructor();
    constructor(data : WartsilaDataCacheUpdateEntitiesOptions);
    constructor(data: WartsilaDataCacheUpdateEntitiesOptions | null = null) {
	    
        this.EnhancedEstimateQueries = SArray<EnhancedEstimateQuery>([]);
        this.EnhancedEstimates = SArray<EnhancedEstimate>([]);
	    
    }

    static key(obj : WartsilaDataCacheUpdateEntities) {
        return ;
    }
    
    static dataKey(obj : WartsilaDataCacheUpdateEntitiesOptions) {
        return ;
    }

    static update(obj : WartsilaDataCacheUpdateEntities, data : WartsilaDataCacheUpdateEntitiesOptions) {
        S.freeze(() => {
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/WartsilaDataCacheUpdateEntities.ts